<template>
    <div class="animated fadeIn">
        <b-row class="py-2">
            <b-card class="w-75 mx-auto" md="10"><!--condition to show content-->
                <b-form @submit.prevent="store" enctype="multipart/form-data">
                    <div class="progress-group">
                        <div class="progress-group-header">
                            <i class="cui-user progress-group-icon"></i>
                            <div>Información adicional</div>
                            <div class="ml-auto font-weight-bold">Paso 4 de 4</div>
                        </div>
                        <div class="progress-group-bars">
                            <div class="progress progress-xs">
                                <div
                                    class="progress-bar bg-success"
                                    role="progressbar"
                                    style="width: 100%"
                                    aria-valuenow="100"
                                    aria-valuemin="0"
                                    aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                    </div>

                    <b-row class="px-4 py-4 mx-0 bg-light">
                        <b-row class="w-100">
                            <b-col class="col-md-6">
                                <b-row class="w-100 pl-4 pt-2">
                                    <b-button variant="primary" class="btn-brand" @click="$refs.cnaeModal.show()">
                                        <i class="fa fa-barcode"></i><span>Agregar Actividades (CNAE)</span>
                                    </b-button>
                                </b-row>
                                <b-row class="w-100 pl-4 pt-2">
                                    <b-button variant="primary" class="btn-brand" @click="$refs.agreementModal.show()">
                                        <i class="fa fa-ticket"></i><span>Aplicar Convenios</span></b-button>
                                </b-row>
                                <b-row class="w-100 pl-4 pt-2">
                                    <b-button variant="primary" class="btn-brand" @click="$refs.associatedProjectModal.show()">
                                        <i class="fa fa-product-hunt"></i><span>Aplicar Proyectos Asociados</span></b-button>
                                </b-row>
                                <b-row class="w-100 pl-4 pt-2">
                                    <b-button variant="primary" class="btn-brand" @click="$refs.attachmentModal.show()">
                                        <i class="fa fa-file"></i><span>Adjuntar Documentos</span></b-button>
                                </b-row>
                                <b-row class="w-100 pl-4 pt-2">
                                    <b-button variant="primary" class="btn-brand" @click="$refs.noteModal.show()"><i
                                        class="fa cui-note"></i><span>Agregar Notas</span></b-button>
                                </b-row>
                                <b-row class="w-100 pl-4 pt-2">
                                    <b-button variant="primary" class="btn-brand" @click="$refs.unlinkedModal.show()">
                                        <i class="fa fa-user"></i><span>Agregar Socios Vinculados</span></b-button>
                                </b-row>
                            </b-col>

                            <b-col class="col-md-6 pl-4">
                                <!-- Gestor Comercial !-->
                                <b-form-group
                                    label="<strong>Gestor Comercial</strong>"
                                    label-for="businessManager"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <multiselect
                                        name="businessManager"
                                        v-model="selected.businessManager"
                                        :options="filterActiveStatusUsers(users, 'COMERCIAL')"
                                        track-by="uuid"
                                        :custom-label="customLabel"
                                        :multiple="false"
                                        :allowEmpty="true"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        v-if="users"
                                        autocomplete="off">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{ props.option.firstname }} {{ props.option.lastname }}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <small>{{ props.option.firstname }} {{ props.option.lastname }}</small>
                                            <pre v-if="props.option.department">{{ props.option.department.description}}</pre>
                                        </template>
                                    </multiselect>
                                </b-form-group>

                                <!-- Gestor de Afiliación !-->
                                <b-form-group
                                    label="<strong>Gestor de Afiliación</strong>"
                                    label-for="affiliationManager"
                                    :horizontal="false"
                                    class="w-100 mt-3 mb-0">
                                    <multiselect
                                        name="affiliationManager"
                                        v-model="selected.affiliationManager"
                                        :options="filterUsers(users, 'GESTION SOCIOS')"
                                        track-by="uuid"
                                        :custom-label="customLabel"
                                        :multiple="false"
                                        :allowEmpty="true"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        v-if="users"
                                        autocomplete="off">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{ props.option.firstname }} {{ props.option.lastname }}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <small>{{ props.option.firstname }} {{ props.option.lastname }}</small>
                                            <pre v-if="props.option.department">{{ props.option.department.description}}</pre>
                                        </template>
                                    </multiselect>
                                </b-form-group>

                                <!-- Gestor de devoluciones !-->
                                <b-form-group
                                    label="<strong>Gestor de devoluciones</strong>"
                                    label-for="returnManager"
                                    :horizontal="false"
                                    class="w-100 mt-3 mb-0">
                                    <multiselect
                                        name="returnManager"
                                        v-model="selected.returnManager"
                                        :options="filterUsers(users, 'ADMINISTRACION')"
                                        track-by="uuid"
                                        :custom-label="customLabel"
                                        :multiple="false"
                                        :allowEmpty="true"
                                        placeholder="Seleccione"
                                        selectLabel="+"
                                        deselectLabel="-"
                                        v-if="users"
                                        autocomplete="off">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{ props.option.firstname }} {{ props.option.lastname }}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <small>{{ props.option.firstname }} {{ props.option.lastname }}</small>
                                            <pre v-if="props.option.department">{{ props.option.department.description}}</pre>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-row>
                    <b-row class="pt-3">
                        <div class="col float-left">
                            <router-link
                                class="btn btn-brand btn-danger btn-lg pull-left"
                                :to="{ path:'/partners/accounts/list'}">Cancelar
                            </router-link>
                            <button
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!validate()">
                                Finalizar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-card>
        </b-row>

        <!-- CNAE !-->
        <b-modal
            id="cnaeModal"
            ref="cnaeModal"
            hide-footer
            class="text-center"
            title="Agregar Actividades"
            centered>
            <b-form @submit.prevent="addCnae">
                <b-form-group label="<strong>CNAE</strong>" label-for="cnae" :horizontal="true" class="w-100 mt-3 mb-0">
                    <cnae-multiple-selector
                        name="cnae"
                        v-model="myCnaes"></cnae-multiple-selector>
                </b-form-group>
                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right" sm="12">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>

        <!-- Convenios !-->
        <b-modal
            id="agreementModal"
            ref="agreementModal"
            hide-footer
            class="text-center"
            title="Aplicar Convenios"
            centered>
            <b-form @submit.prevent="addAgreement">
                <b-row>
                    <b-col offset-md="1" md="10">
                        <b-form-group
                            label="<strong>Convenio *</strong>"
                            label-for="agreement"
                            :horizontal="true"
                            class="w-100 mt-2 mb-0 text-left">
                            <common-agreement-selector
                                :headquartersId="entity.headquartersId"
                                v-model="newAgreement.agreement"></common-agreement-selector>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col offset-md="1" md="10">
                        <b-form-group
                            label="<strong>Fecha de aplicación</strong>"
                            label-for="applicationDate"
                            :horizontal="true"
                            class="w-100 mb-3 text-left">
                            <v-date-picker
                                name="applicationDate"
                                v-model='newAgreement.applicationDate'
                                class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                :required="true">
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="flex-row justify-content-center m-1">
                    <div
                        v-for="agreement in myAgreements"
                        :key="agreement.uuid"
                        class="bg-primary text-white p-1 m-1">
                        {{ agreement.name }}
                    </div>
                </b-row>
                <!-- !-->
                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg float-right"
                        sm="12"
                        :disabled="!newAgreement.agreement">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>

        <!-- Proyectos asociados -->
        <b-modal
            id="associatedProjectModal"
            ref="associatedProjectModal"
            hide-footer
            class="text-center"
            title="Aplicar Proyecto Asociado"
            centered
            v-if="associatedProjects">
            <b-form @submit.prevent="addAssociatedProject">
                <b-row>
                    <b-col offset-md="1" md="10">
                        <b-form-group
                            label="<strong>Proyecto Asociado *</strong>"
                            label-for="associatedProject"
                            :horizontal="true"
                            class="w-100 mt-2 mb-0 text-left">
                            <multiselect
                                ref="associatedProject"
                                name="associatedProject"
                                v-model="newAssociatedProject.associatedProject"
                                :options="memberAssociatedProjects"
                                label="name"
                                track-by="uuid"
                                :multiple="false"
                                :allowEmpty="false"
                                placeholder="Seleccione"
                                selectLabel="+"
                                deselectLabel="-"></multiselect>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col offset-md="1" md="10">
                        <b-form-group
                            label="<strong>Fecha de aplicación</strong>"
                            label-for="applicationDate"
                            :horizontal="true"
                            class="w-100 mb-3 text-left">
                            <v-date-picker
                                name="applicationDate"
                                v-model='newAssociatedProject.applicationDate'
                                :min-date='newAssociatedProject.associatedProject.startDate'
                                :max-date='newAssociatedProject.associatedProject.endDate'
                                class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                :required="true">
                            </v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="flex-row justify-content-center m-1">
                    <div
                        v-for="associatedProject in myAssociatedProjects"
                        :key="associatedProject.uuid"
                        class="bg-primary text-white p-1 m-1">
                        {{ associatedProject.name }}
                    </div>
                </b-row>
                <!-- !-->
                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg float-right"
                        sm="12"
                        :disabled="!newAssociatedProject.associatedProject.uuid || !newAssociatedProject.applicationDate">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>

        <!-- Documento !-->
        <b-modal
            id="attachmentModal"
            ref="attachmentModal"
            hide-footer
            class="text-center"
            title="Adjuntar Documentos"
            centered>
            <b-form @submit.prevent="addAttachments" enctype="multipart/form-data">
                <b-form-group
                    label="<strong>Documento</strong>"
                    label-for="attachment"
                    :horizontal="false"
                    class="w-100 my-2">
                    <b-form-file
                        id="attachment"
                        v-model="myAttachment"
                        :state="Boolean(myAttachment)"
                        placeholder="Seleccione documento...">
                    </b-form-file>
                </b-form-group>
                <b-list-group class="my-3">
                    <b-list-group-item
                        v-for="(item, i) in myAttachments"
                        :key="`${i}-${item.uuid}`"
                        target="_blank">
                        <i class="fa fa-file mr-1"></i> {{ item.name }}
                    </b-list-group-item>
                </b-list-group>
                <b-row class="border-top mt-2 pt-3 px-3 flex-row-reverse">
                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right" sm="12">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>

        <!-- Nota !-->
        <b-modal id="noteModal" ref="noteModal" hide-footer class="text-center" title="Agregar Notas" centered>
            <b-form @submit.prevent="addNotes">
              <b-form-group
                label="<strong>Tipo De Nota</strong>"
                label-for="Tipo-De-Nota"
                :horizontal="true" class="w-100">
                <multiselect id="Tipo-De-Nota" v-model="myNoteType" :multiple="false"
                             :options="noteTypes.map(option => option.uuid)"
                             :customLabel="value => (noteTypes.find(option => option.uuid === value).name)"
                             placeholder="Seleccione" required>
                </multiselect>
              </b-form-group>
                <b-form-group label="<strong>Nota</strong>" label-for="note" :horizontal="true" class="w-100 my-2">
                    <b-form-textarea
                        id="note"
                        v-model="myNote"
                        placeholder="Agregue su nota"
                        :rows="3"
                        :max-rows="6">
                    </b-form-textarea>
                </b-form-group>
                <b-list-group class="my-3">
                    <b-list-group-item
                        v-for="(item, i) in myNotes"
                        :key="`${i}-${item.uuid}`"
                        class="my-1"
                        style="background-color: lightgoldenrodyellow">
                        {{ item.note }}
                    </b-list-group-item>
                </b-list-group>
                <b-row class="border-top mt-2 pt-3 px-3 flex-row-reverse">
                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right" sm="12">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>

        <!-- Miembro vinculado !-->
        <b-modal
            id="unlinkedModal"
            ref="unlinkedModal"
            hide-footer
            class="text-center"
            size="lg"
            title="Agregar Socios Vinculados"
            centered>
            <b-form @submit.prevent="addUnlinkeds">
                <b-container>
                    <b-row md="12" class="pb-3">
                        <b-col md="6">
                            <!-- Nombre !-->
                            <b-form-group
                                label="<strong>Nombre *</strong>"
                                label-for="name"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <b-form-input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Nombre"
                                    autocomplete="off"
                                    v-model="unlinked.name"
                                    class="w-100"
                                    v-validate="'required|min:3'"
                                    :state="validateState('name')"
                                    aria-describedby="check_name">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_name">
                                    <small>{{ errors.first('name') }}</small>
                                </div>
                            </b-form-group>

                            <!-- Apellidos !-->
                            <b-form-group
                                label="<strong>Apellidos *</strong>"
                                label-for="surname"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <b-form-input
                                    id="surname"
                                    name="surname"
                                    type="text"
                                    placeholder="Apellidos"
                                    autocomplete="off"
                                    v-model="unlinked.surname"
                                    class="w-100"
                                    v-validate="'required|min:3'"
                                    :state="validateState('surname')"
                                    aria-describedby="check_surname">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_surname">
                                    <small>{{ errors.first('surname') }}</small>
                                </div>
                            </b-form-group>

                            <!-- NIF !-->
                            <b-form-group
                                label="<strong>NIF *</strong>"
                                label-for="nif"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <b-form-input
                                    id="nif"
                                    name="nif"
                                    type="text"
                                    placeholder="NIF"
                                    autocomplete="off"
                                    v-model="unlinked.nif"
                                    class="w-100"
                                    v-validate="'required|nif'"
                                    :state="validateState('nif')"
                                    aria-describedby="check_nif">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_nif">
                                    <small>{{ errors.first('nif') }}</small>
                                </div>
                            </b-form-group>

                            <!-- Sexo !-->
                            <b-form-group
                                label="<strong>Sexo *</strong>"
                                label-for="sex"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <multiselect
                                    name="sex"
                                    v-model="unlinked.sex"
                                    :options="sex.map(type => type.uuid)"
                                    :custom-label="opt => sex.find(x => x.uuid == opt).name"
                                    :multiple="false"
                                    :allowEmpty="false"
                                    placeholder="Seleccione"
                                    autocomplete="off"
                                    selectLabel="+"
                                    deselectLabel="-"
                                    v-if="sex">
                                </multiselect>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <!-- Cumpleaños !-->
                            <b-form-group
                                label="<strong>Fecha de Nacimiento *</strong>"
                                label-for="birthday"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <v-date-picker
                                    v-model='unlinked.birthday'
                                    :max-date="new Date()"
                                    class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                    :required="true">
                                </v-date-picker>
                                <div class="text-danger text-right" id="check_birthday">
                                    <small>{{ errors.first('birthday') }}</small>
                                </div>
                            </b-form-group>

                            <!-- Email !-->
                            <b-form-group
                                label="<strong>Email</strong>"
                                label-for="email"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <b-form-input
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="Email"
                                    autocomplete="off"
                                    v-model="unlinked.email"
                                    class="w-100"
                                    v-validate="'email'"
                                    :state="validateState('email')"
                                    aria-describedby="check_email">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_email">
                                    <small>{{ errors.first('email') }}</small>
                                </div>
                            </b-form-group>

                            <!-- Teléfono !-->
                            <b-form-group
                                label="<strong>Teléfono</strong>"
                                label-for="phone"
                                :horizontal="false"
                                class="w-100 mb-3 text-left">
                                <b-form-input
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    placeholder="Teléfono"
                                    autocomplete="off"
                                    v-model="unlinked.phone"
                                    class="w-100"
                                    v-validate="'phone'"
                                    :state="validateState('phone')"
                                    aria-describedby="check_phone">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_phone">
                                    <small>{{ errors.first('phone') }}</small>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="flex-row justify-content-center m-1">
                        <div
                            v-for="(item, i) in myUnlinkeds"
                            :key="`${i}-${item.uuid}`"
                            class="bg-primary text-white p-1 m-1">
                            {{ item.name }} {{ item.surname }}
                        </div>
                    </b-row>
                </b-container>
                <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                    <button type="submit" class="btn btn-brand btn-primary col-auto btn-lg float-right" sm="12">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import {request} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import form from '@/helpers/form';
    import {isFeeAgreementType} from '@/helpers/agreement-helper';
    import {filterUsers, filterActiveStatusUsers} from '@/helpers/user-helper';
    import {
        applyAgreementToMember,
        stopApplyingAgreementToMember
    } from '@/api/member-api';
    import {
        getAssociatedProjects,
        getMemberAssociatedProjects,
        applyAssociatedProjectToMember
    } from '@/api/associated-project-api';
    import commonAgreementSelector from '@/components/agreements/CommonAgreementSelector';
    import cnaeMultipleSelector from '@/components/clients/cnaes/CnaeMultipleSelector';

    setupCalendar({
        firstDayOfWeek: 2, // Monday
    });

    export default {
        name: 'addPartners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            commonAgreementSelector,
            cnaeMultipleSelector
        },
        props: ['partner'],
        data: function () {
            return {
                // view
                topmenu: [
                    {name: 'Volver', path: '/admin/agreements/list', brand: 'fa fa-arrow-left'},
                ],
                title: 'Nuevo Socio',
                subtitle: 'Paso 3 de 4',
                entity: {
                    businessManager: null,
                    affiliationManager: null,
                    returnManager: null,
                    welcomeMail: true,
                    includeMemberCard: true,
                    headquartersId: null
                },
                unlinked: {
                    nif: null,
                    name: null,
                    surname: null,
                    sex: null,
                    birthday: null,
                    email: null,
                    phone: null,
                    memberId: null,
                },
                // dependencies
                associatedProjects: [],
                businessManagers: [],
                affiliationManagers: [],
                returnManagers: [],
                selected: {
                    businessManager: null,
                    affiliationManager: null,
                    returnManager: null,
                },
                sex: [
                    {uuid: 1, name: 'Hombre'},
                    {uuid: 2, name: 'Mujer'},
                    {uuid: 3, name: 'Otra identidad'},
                ],
                users: [],
                myCnaes: [],
                myAgreements: [],
                myAssociatedProjects: [],
                newAgreement: {
                    agreement: null,
                    applicationDate: null
                },
                newAssociatedProject: {
                    associatedProject: {},
                    applicationDate: null
                },
                noteTypes: [],
                myNotes: [],
                myNoteType: '',
                myNote: null,
                myAttachments: [],
                myAttachment: null,
                myUnlinkeds: [],
                today: null
            }
        },
        mounted() {
            this.entity = Object.assign({}, this.entity, this.partner);
            this.requests('users?headquartersId=' + this.partner.headquarters.uuid, 'get', 200, 'users');
            this.requests('members/' + this.partner.uuid + '/cnae', 'get', 200, 'myCnaes');
            this.requests('members/' + this.partner.uuid + '/agreements', 'get', 200, 'myAgreements');
            this.requests('clients/' + this.partner.uuid + '/attachments', 'get', 200, 'myAttachments');
            this.requests('clients/' + this.partner.uuid + '/notes', 'get', 200, 'myNotes');
            this.requests('clients/notesType', 'get', 200, 'noteTypes');
            this.requests('members/' + this.partner.uuid + '/unlinked-members', 'get', 200, 'myUnlinkeds');

            getAssociatedProjects(this.partner.uuid).then((associatedProjects) => this.associatedProjects = associatedProjects);
            getMemberAssociatedProjects(this.partner.uuid).then((associatedProjects) => this.myAssociatedProjects = associatedProjects);

            this.today = new Date();
        },
        computed: {
            memberAssociatedProjects() {
                return this.associatedProjects.filter((associatedProject) => {
                    return !this.myAssociatedProjects.find((myAssociatedProject) => {
                       return associatedProject.uuid === myAssociatedProject.uuid;
                    });
                });
            }
        },
        methods: {
            filterUsers: filterUsers,
            filterActiveStatusUsers: filterActiveStatusUsers,
            customLabel({firstname, lastname}) {
                return `${firstname} – ${lastname}`;
            },
            store() {
                this.$_loadingMixin_showLoading();
                let self = this;
                try {
                    this.bindSelectedManagersToEntity();
                    request('/members/' + this.partner.uuid + '/steps/4', 'post', 200, this.entity).then(x => {
                        self.setPartner(x);
                        self.$_loadingMixin_hideLoading();
                        self.$router.push('/partners/accounts/list');
                    });
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    this.$_loggerMixin_consoleLog(error);
                }
            },
            bindSelectedManagersToEntity() { // TODO: refactor
                if (!!this.selected.businessManager && !!this.selected.businessManager.uuid) {
                    this.entity.businessManager = this.selected.businessManager.uuid;
                } else {
                    this.entity.businessManager = null;
                }
                if (!!this.selected.affiliationManager && !!this.selected.affiliationManager.uuid) {
                    this.entity.affiliationManager = this.selected.affiliationManager.uuid;
                } else {
                    this.entity.affiliationManager = null;
                }
                if (!!this.selected.returnManager && !!this.selected.returnManager.uuid) {
                    this.entity.returnManager = this.selected.returnManager.uuid;
                } else {
                    this.entity.returnManager = null;
                }
            },
            bindEntityManagersToSelected() { // TODO: refactor
                let self = this;
                if (this.entity.businessManager) {
                    this.selected.businessManager = this.users.find(function(user) {
                        return user.uuid.includes(self.entity.businessManager)
                    });
                }
                if (this.entity.affiliationManager) {
                    this.selected.affiliationManager = this.users.find(function(user) {
                        return user.uuid.includes(self.entity.affiliationManager)
                    });
                }
                if (this.entity.returnManager) {
                    this.selected.returnManager = this.users.find(function(user) {
                        return user.uuid.includes(self.entity.returnManager)
                    });
                }
            },
            addCnae() {
                this.$_loadingMixin_showLoading();
                let self = this;
                try {
                    let cns = this.myCnaes.map(c => c.uuid);
                    request('/members/' + self.partner.uuid + '/cnae', 'post', 200, {cnaes: cns}).then(x => {
                        self.$_loadingMixin_hideLoading();
                        self.requests('members/' + self.partner.uuid + '/cnae', 'get', 200, 'myCnaes');
                    });
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    this.$_loggerMixin_consoleLog(error);
                }
            },
            async addAgreement() {
                if (!!this.newAgreement.agreement && !!this.newAgreement.agreement.uuid) {
                    this.$_loadingMixin_showLoading();
                    await applyAgreementToMember(
                        this.partner.uuid,
                        this.newAgreement.agreement.uuid,
                        this.newAgreement.applicationDate
                    )
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'El convenio ha sido aplicado');
                            this.requests('members/' + this.partner.uuid + '/agreements', 'get', 200, 'myAgreements');
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Error en la operación', 'No se ha podido aplicar el convenio');
                        });
                    this.$_loadingMixin_hideLoading();
                }
            },

            async addAssociatedProject() {
                if (!!this.newAssociatedProject.associatedProject && !!this.newAssociatedProject.associatedProject.uuid) {
                    this.$_loadingMixin_showLoading();
                    await applyAssociatedProjectToMember(
                        this.partner.uuid,
                        this.newAssociatedProject.associatedProject.uuid,
                        this.newAssociatedProject.applicationDate
                    )
                        .then(() => {
                            this.$_notificationMixin_success('Operación completada', 'El proyecto ha sido aplicado');
                            this.newAssociatedProject = {
                                associatedProject: {},
                                applicationDate: null
                            };
                            getMemberAssociatedProjects(this.partner.uuid).then((associatedProjects) => this.myAssociatedProjects = associatedProjects);
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Error en la operación', 'No se ha podido aplicar el proyecto');
                        });
                    this.$_loadingMixin_hideLoading();
                }
            },

            addAttachments() {
                this.$_loadingMixin_showLoading();
                let self = this;
                try {
                    request('/clients/' + this.partner.uuid + '/attachment', 'post', 201, form.objectToFormData({attachment: this.myAttachment})).then(x => {
                        self.myAttachment = null;
                        self.$_loadingMixin_hideLoading();
                        self.requests('clients/' + self.partner.uuid + '/attachments', 'get', 200, 'myAttachments');
                    });
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    this.$_loggerMixin_consoleLog(error);
                }
            },
            addNotes() {
                this.$_loadingMixin_showLoading();
                let self = this;

                try {
                    request('/clients/' + this.partner.uuid + '/note', 'post', 201, {note: this.myNote, note_type_id: this.myNoteType}).then(x => {
                        self.myNote = null;
                        self.myNoteType = null;
                        self.$_loadingMixin_hideLoading();
                        self.requests('clients/' + self.partner.uuid + '/notes', 'get', 200, 'myNotes');
                    });
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    this.$_loggerMixin_consoleLog(error);
                }
            },
            addUnlinkeds() {
                this.$_loadingMixin_showLoading();
                let self = this;
                try {
                    this.unlinked.memberId = this.partner.uuid;
                    request('/unlinked-member', 'post', 201, this.unlinked).then(x => {
                        self.unlinked.nif = null;
                        self.unlinked.name = null;
                        self.unlinked.surname = null;
                        self.unlinked.sex = null;
                        self.unlinked.birthday = null;
                        self.unlinked.email = null;
                        self.unlinked.phone = null;
                        self.unlinked.memberId = null;
                        self.$validator.reset();
                        self.$_loadingMixin_hideLoading();
                        self.requests('members/' + self.partner.uuid + '/unlinked-members', 'get', 200, 'myUnlinkeds');
                    });
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    this.$_loggerMixin_consoleLog(error);
                }
            },
            async requests(path, method, okCode, entity) {
                this.$_loadingMixin_showLoading();
                this[entity] = await request(path, method, okCode);
                this.$_loadingMixin_hideLoading();
            },
            validate() {
                // currently there are not required fields
                return true;
            },
            setPartner(entity) {
                this.$emit('sendPartner', entity);
            }
        },
        watch: {
            users: function () { // TODO: refactor
                this.bindEntityManagersToSelected();
            }
        }
    }
</script>
